export const linkStyles = {
    color: '#405BD8',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '24px', /* 171.429% */
}

export const linkStylesToLoginPage = {
    color: '#595959',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '24px',
}
